import {suspendUserManagementUser} from "@project/sdk/user-management";
import {
  SuspendUserManagementUserHeader,
  SuspendUserManagementUserResponse,
} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function suspendUserManagementUserMutationOptions() {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.suspendUserManagementUser,
    mutationFn: async ({userId, idempotencyKey}: {userId: string; idempotencyKey: string}) =>
      SuspendUserManagementUserResponse.parse(
        await suspendUserManagementUser(userId, {
          headers: SuspendUserManagementUserHeader.parse({"Idempotency-Key": idempotencyKey}),
        }),
      ),
    onSuccess: async (_data, {userId}, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: userManagementUserKeys.detail(userId)}),
        client.invalidateQueries({queryKey: userManagementUserKeys.lists()}),
      ]);
    },
  });
}
